import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import { IssueFilterKeys } from '../../../../../shared/issuesV2';
import { VulnSeverityMapping, vulnSeverityMappingToString } from '../../../../../shared/vulns/severity';
import * as IssuesV2Store from '../../../../redux/issuesV2';
import { useSetFilterHasChanged } from '../../../../redux/savedFilters/hooks';
import { FilterPanel } from '../../../generic/Filter';
import FilterCardCheckboxes from '../../../generic/Filter/FilterCardCheckboxes';
import useFetchIssuesAction from '../../IssuesInbox/hooks/useFetchIssuesAction';
import type { SelectOption } from '../../../../types';
import type { SelectedOptionsProps } from '../../../generic/Filter';

const FILTER_OPTIONS: SelectOption[] = [
  { value: vulnSeverityMappingToString(VulnSeverityMapping.CRITICAL), label: 'Critical (9-10)' },
  { value: vulnSeverityMappingToString(VulnSeverityMapping.HIGH), label: 'High (7-8.9)' },
  { value: vulnSeverityMappingToString(VulnSeverityMapping.MEDIUM), label: 'Medium (4-6.9)' },
  { value: vulnSeverityMappingToString(VulnSeverityMapping.LOW), label: 'Low (0.1-3.9)' },
  { value: vulnSeverityMappingToString(VulnSeverityMapping.UNKNOWN), label: 'Unknown' },
];

const SeverityFilter: VoidFunctionComponent<Omit<SelectedOptionsProps, 'onSelect'>> = ({ selectedOptions }) => {
  const setFilters = useFetchIssuesAction(IssuesV2Store.actions.setFilter);
  const stateFilters = useSelector(IssuesV2Store.selectors.getFilter);
  const setFilterHasChanged = useSetFilterHasChanged();

  const selectedCheckboxes = (selectedOptions ?? []).map((option: string) => ({
    label: FILTER_OPTIONS.find(filterOption => filterOption.value === option)?.label || option,
    value: option,
  }));

  const onCheckboxChange = (newSelected: SelectOption[]) => {
    setFilters({
      ...stateFilters,
      [IssueFilterKeys.Severity]: newSelected.map(({ value }) => value),
    });
    setFilterHasChanged(true);
  };

  return (
    <FilterPanel>
      <FilterCardCheckboxes
        label="Severity"
        options={FILTER_OPTIONS}
        values={selectedCheckboxes}
        onChange={onCheckboxChange}
        testId="issues-vuln-severity"
      />
    </FilterPanel>
  );
};

export default SeverityFilter;
